import { useState, ReactNode, useEffect } from "react";
import { Layout } from "../../components";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { cmsBlockActionDispatch } from "../../store/cmsBlock/actions";
import { selectFooterSelector } from "../../store/cmsBlock/selector";
import { currencyActionDispatch } from "../../store/currency/actions";
import { storeConfigActionDispatch } from "../../store/storeConfig/actions";
import { selectStoreConfigSelector } from "../../store/storeConfig/selector";
import {
  layoutQueries,
  manageCartData,
  packageQueries,
} from "./serviceManager";
import { PageLoader } from "../../components/loaders/pageLoader";
import Notification from "../../components/notification";
import { selectNotificationSelector } from "../../store/notification/selectors";
import { cartActionDispatch } from "../../store/cart/actions";
import { categoryInfoActionDispatch } from "../../store/category/actions";
import { packageActionDispatch } from "../../store/packages/actions";

interface PageLayoutProps {
  children: ReactNode;
  pageTitle?: string;
  metaContent?: string;
  metaName?: string;
}

const PageLayout = (props: PageLayoutProps) => {
  const { setStoreConfig, setPaymentFrequencyConfig } = storeConfigActionDispatch(useAppDispatch());
  const { setCurrency } = currencyActionDispatch(useAppDispatch());
  const { setFooter } = cmsBlockActionDispatch(useAppDispatch());
  const { setBundlePackages, setVirtualPackages } =
    packageActionDispatch(useAppDispatch());
  const { setCart } = cartActionDispatch(useAppDispatch());
  const { setCategory } = categoryInfoActionDispatch(useAppDispatch());

  const storeData = useAppSelector(selectStoreConfigSelector);
  const notification = useAppSelector(selectNotificationSelector);
  const cmsBlock = useAppSelector(selectFooterSelector);

  const [loader, setLoader] = useState({
    storeConfig: true,
    currency: true,
    footer: true,
  });
  const [configLoader, setConfigLoader] = useState({ cart: true });
  const [packageLoader, setPackageLoader] = useState({
    features: true,
    bundlePackage: true,
    virtualPackage: true,
    categoryInfo: true,
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    await layoutQueries(
      loader,
      setLoader,
      setFooter,
      setCurrency,
      setStoreConfig,
      setPaymentFrequencyConfig
    );
    await manageCartData(configLoader, setConfigLoader, setCart);
    await packageQueries(
      packageLoader,
      setPackageLoader,
      setBundlePackages,
      setVirtualPackages,
      setCategory
    );
  };

  const checkIfAnyTrue = (obj: any) => {
    return Object.values(obj).some((value) => value === true);
  };

  const checkDataLoadedStatus = () => {
    let loadingCompleted = false;
    let packageLoaded = checkIfAnyTrue(packageLoader);
    let layoutLoaded = checkIfAnyTrue(loader);
    let cartLoaded = checkIfAnyTrue(configLoader);
    if (packageLoaded && !layoutLoaded && !cartLoaded) {
      loadingCompleted = true;
    }
    return loadingCompleted;
  };

  return checkDataLoadedStatus() ? (
    <>
      <Layout
        pageTitle={props.pageTitle ?? storeData.default_title}
        metaContent={props.metaContent ?? storeData.default_description}
        metaName={"description"}
        logoAlt={storeData.logo_alt ?? ""}
        footerData={cmsBlock?.items[0]?.content}
        logo={`${storeData?.base_media_url}logo/${storeData?.header_logo_src}`}
      >
        {props.children}
      </Layout>
      <Notification notification={notification} />
    </>
  ) : (
    <PageLoader />
  );
};

export default PageLayout;
